import axios from "axios";
import _ from "lodash";

export default {
  namespaced: true,
  state: {
    croppFlag: false,
    media_data: [],
    media_data_default: [],
    media_type: ["Все файлы", "Фото", "Видео", "Аудио"],
    media_file: null,
    media_tags: [],
    media_data_autocomplit: [],
  },
  getters: {
    mediaData: (state) => state.media_data.reverse(),
    mediaType: (state) => state.media_type,
    mediaDataAutocomplit: (state) => state.media_data_autocomplit,
    mediaFile: (state) => state.media_file,
    mediaTags: (state) => state.media_tags,
    getCroppFlag: (state) => state.croppFlag,
  },
  mutations: {
    setCroppFlag(state, payload) {
      state.croppFlag = payload;
    },
    getAllMutation(state, data) {
        for (let i = 0; i < data.length; i++) {
            data[i].mediaFileTagsList = [];
            data[i].mediaFileTagsSearch = '';

            if(data[i].mediaFileTags && data[i].mediaFileTags.length > 0) {
                for (let j = 0; j < data[i].mediaFileTags.length; j++) {
                    data[i].mediaFileTagsList.push(data[i].mediaFileTags[j].mediaFileTag.tagName);
                    data[i].mediaFileTagsSearch = `${data[i].mediaFileTagsSearch.length > 0 ? data[i].mediaFileTagsSearch+', ' : ''}${data[i].mediaFileTags[j].mediaFileTag.tagName}`
                }
            }
        }

        state.media_data = data
        state.media_data_default = JSON.parse(JSON.stringify(data));
        state.media_data_autocomplit = data.map((item, index) => {
            return {
            text: item.fileName,
            value: index,
            url: item.fileUrl,
            id: item.id,
            };
        });
    },
    mediaFilter(state, filter) {
        state.media_data = state.media_data_default;

        if (filter.author) {
            state.media_data = _.filter(state.media_data, function (o) {
                return o.createdBy == filter.author;
            });
        }

        if (filter.fileType.length && filter.fileType !== "Все файлы") {
            state.media_data = _.filter(state.media_data, function (o) {
                const type = (_.last(o.fileName.split("."))).toLowerCase();
                if (filter.fileType == "Фото") {
                    return (
                        type == "png" || type == "jpg" || type == "jpeg" || type == "GIF"
                    );
                } else if (filter.fileType == "Видео") {
                    return type == "mp4";
                } else if (filter.fileType == "Аудио") {
                    return type == "mp3";
                } else if (filter.fileType == "Текст") {
                    return type == "docx";
                }
            });
        }
        
        console.log('mediaFilter', filter.author, state.media_data);
    },
    getFileMutation(state, file) {
      state.media_file = file;
    },
    addFile(state, file) {
      state.media_data.push(file);
    },
    setDeleteItem(state, file) {
      state.media_data.forEach((item, i) => {
        if (file === item.id) {
          state.media_data.splice(i, 1);
        }
      });
    },
    setUodate(state, file) {
    //   console.log(file);
    },
    getAllTag(state, tags) {
      state.media_tags = tags.map((item) => {
        return item.tagName;
      });
    },
    saveNewTags(state, tag) {
      state.media_tags.push(tag);
    },
  },
  actions: {
    create({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        const tags = data.tags.length
          ? data.tags
              .map((item) => {
                return `&tags=${item}`;
              })
              .join("")
          : "";
        const formData = new FormData();
        // console.log(data.file);
        formData.append("File", data.file);
        axios
          .post(
            `${rootState.api}Media/Create?ftitle=${data.ftitle}&desc=${data.desc}${tags}`,
            formData,
            {
              "Content-Type": "multipart/form-data",
            }
          )
          .then((resp) => {
            commit("addFile", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateFile({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        const tags = data.tags.length
          ? data.tags
              .map((item) => {
                return `&tags=${item}`;
              })
              .join("")
          : "";
        axios
          .post(
            `${rootState.api}Media/Update?ftitle=${data.ftitle}&desc=${data.desc}&id=${data.id}${tags}`
          )
          .then((resp) => {
            commit("setUodate", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    removeTag({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}Media/RemoveTag`, data)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    delete({ commit, rootState }, item) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}Media/Delete?fileid=${item.id}`)
          .then((resp) => {
            commit("setDeleteItem", item.id);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    download({ commit, rootState }, file) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}Media/Download?fileid=${file.id}`, {
            responseType: "arraybuffer",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/Docx",
            },
          })
          .then((resp) => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${file.fileName}`); //or any other extension
            document.body.appendChild(link);
            link.click();
            commit("getFileMutation", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getFile({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}Media/Get?fileid=${id}`)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getFiles({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}Media/GetAll`)
          .then((resp) => {
            commit("getAllMutation", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getTags({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}Tag/Search`)
          .then((resp) => {
            commit("getAllTag", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
